import React, { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faLock } from "@fortawesome/free-solid-svg-icons";
import linkImg from "../../assets/LOGOHSRP.png";
// import { useCliente } from "../../App/Hooks/global/SocketContext";
import { useUsuario } from "../../App/Hooks/global/UsuarioContext";
import { Button, Card, Input, message, Spin } from "antd";
import { Container } from "App/components/core/skeleton/Container";
import { Column, Heading, Row, Typography } from "core/util-styled-components";
import { useMediaQueryCustom } from "App/Hooks/useMediaQueryCustom";
import { blue } from "@ant-design/colors";
import { useNavigate } from "react-router-dom";

export default function Autenticacion() {
  // const { socketReconect } = useCliente();
  const { login, usuario } = useUsuario();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();
  const { isTabletOrMobile } = useMediaQueryCustom();

  const iniciarSesion = async (e) => {
    e.preventDefault();
    message.loading("Iniciando Sesion...", 0);

    const msg = await login(username, password);

    const [head, body, code] = msg;
    if (code === 200) {
      message.destroy();
      message.success(body, 2);
    } else {
      message.destroy();
      message.error(body, 2);
    }

    if (msg[2] === 200) {
      // socketReconect();
    }
  };

  useEffect(() => {
    if (usuario) nav("/");

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);

  return (
    <Container>
      <form onSubmit={(e) => iniciarSesion(e)}>
        <Card
          style={{
            width: isTabletOrMobile ? "96%" : "45%",
            margin: "auto",
          }}
          hoverable
        >
          <Column alignItems="center" gap="1em">
            <img
              src={linkImg}
              alt=""
              style={{
                width: "200px",
              }}
            />
            <Heading variant="h2">Inicio de Sesión para trabajadores</Heading>
            <Input
              id="username"
              className="input-auth w-60 p-10"
              type="text"
              placeholder="Usuario"
              prefix={
                <i className="fa fa-user" style={{ color: blue.primary }} />
              }
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              value={username}
              required={true}
            />
            <Input
              id="password"
              className="input-auth w-60 p-10"
              type="password"
              placeholder="Contraseña"
              prefix={
                <i className="fa fa-lock" style={{ color: blue.primary }} />
              }
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required={true}
            />
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              <Row gap="10px" justifyContent="center">
                <i className="fa fa-lock icon-font-smenu" />
                <Typography color="inherit">
                  <strong>Iniciar Sesion</strong>
                </Typography>
              </Row>
            </Button>
          </Column>
        </Card>
      </form>
    </Container>
  );
}
